<template>
	<div
		:id="uniqueId"
		class="amelipro-dental-chart"
	>
		<div class="d-flex justify-center">
			<AmeliproFilters
				:group-id="`${uniqueId}-filters`"
				group-label="Choisissez le statut à modifier"
				hidden-label
				:items="filterItems"
				unique
				@input="changeFilterValue"
			/>
		</div>

		<slot name="information" />

		<ul class="list-style-none w-100">
			<li
				v-for="(line, index) in currentValue"
				:key="index"
				class="w-100"
			>
				<ul class="list-style-none w-100 d-flex flex-wrap justify-center">
					<li
						v-for="(tooth, toothIndex) in line"
						:key="toothIndex"
						class="mb-4 tooth-item"
					>
						<AmeliproTooth
							:decayed="tooth.decayed"
							:filled="tooth.filled"
							:milk-tooth="index === 0 || index === (currentValue.length - 1) ? true : false"
							:missing="tooth.missing"
							:tooth-number="tooth.toothNumber"
							@click="changeToothStatus(tooth.toothNumber, index)"
						/>
					</li>
				</ul>
			</li>
		</ul>
	</div>
</template>

<script setup lang="ts">
	import { AmeliproDentalChartLine, IAmeliproTooth } from './types';
	import { PropType, computed, ref } from 'vue';
	import AmeliproTooth from './AmeliproTooth';

	const props = defineProps({
		uniqueId: {
			type: String,
			required: true,
		},
		value: {
			type: Array as PropType<AmeliproDentalChartLine[]>,
			required: true,
		},
	});

	const emit = defineEmits(['change', 'change:filter', 'input']);
	const currentValue = computed({
		get: () => props.value,
		set: (newValue: AmeliproDentalChartLine[]) => {
			currentValue.value = newValue;
			emit('input', newValue);
		},
	});

	const filterItems = ref([
		{
			id: 'decayed',
			isChecked: true,
			label: 'Dent cariée',
			value: 'decayed',
		},
		{
			id: 'missing',
			label: 'Dent absente',
			value: 'missing',
		},
		{
			id: 'filled',
			label: 'Dent obturée',
			value: 'filled',
		},
	]);

	const filterValue = ref('decayed');
	const changeFilterValue = (value: string) => {
		filterValue.value = value;
		emit('change:filter', value);
	};

	const changeToothStatus = (toothNumber: string, lineIndex: number) => {
		const tooth = currentValue.value[lineIndex].find((item: IAmeliproTooth) => item.toothNumber === toothNumber);
		if (tooth) {
			if (filterValue.value === 'decayed') {
				tooth.decayed = !tooth.decayed;
			} else if (filterValue.value === 'missing') {
				tooth.missing = !tooth.missing;
			} else if (filterValue.value === 'filled') {
				tooth.filled = !tooth.filled;
			}
			emit('change', currentValue.value);
		}
	};
</script>

<style lang="scss" scoped>
.tooth-item {
	min-width: 2.5rem;
	margin-left: 4px;
	margin-right: 4px;

	@media (max-width: 1239.999px) {
		width: 2.5rem;
	}

	@media (min-width: 1240px) {
		width: 3.125rem;
		margin-left: 8px;
		margin-right: 8px;
	}
}
</style>
